import type { PracticeSentence } from "./types";

export const practiceSentences: PracticeSentence[] = [
  {
    id: "en-ship-sheep",
    language: "en",
    title: "Ship / Sheep contrast",
    text: "The sheep is on the ship.",
    nativeAccent: "General American English",
    focus: ["i", "ɪ", "ʃ"],
    phonemes: [
      {
        id: "en-sheep-iy",
        label: "sheep",
        ipa: "i",
        kind: "vowel",
        start: 0.16,
        end: 0.32,
        target: { f1: 300, f2: 2300, tolerance: 360 },
        cue: "Keep the tongue high and forward; smile slightly without tensing the jaw.",
      },
      {
        id: "en-ship-ih",
        label: "ship",
        ipa: "ɪ",
        kind: "vowel",
        start: 0.74,
        end: 0.9,
        target: { f1: 420, f2: 1900, tolerance: 330 },
        cue: "Relax from /i/: the tongue is still front, but lower and shorter.",
      },
    ],
  },
  {
    id: "es-pero-perro",
    language: "es",
    title: "Pero / Perro contrast",
    text: "Pero el perro corre rápido.",
    nativeAccent: "Central Spanish",
    focus: ["e", "r", "rr", "a"],
    phonemes: [
      {
        id: "es-pero-e",
        label: "pero",
        ipa: "e",
        kind: "vowel",
        start: 0.08,
        end: 0.22,
        target: { f1: 460, f2: 2050, tolerance: 360 },
        cue: "Use a clean mid-front vowel; avoid sliding toward English /ei/.",
      },
      {
        id: "es-rapido-a",
        label: "rápido",
        ipa: "a",
        kind: "vowel",
        start: 0.7,
        end: 0.88,
        target: { f1: 780, f2: 1350, tolerance: 420 },
        cue: "Open the mouth more than English schwa; keep it short and steady.",
      },
    ],
  },
  {
    id: "it-pesca-pesca",
    language: "it",
    title: "Open and closed E",
    text: "La pesca fresca è perfetta.",
    nativeAccent: "Standard Italian",
    focus: ["e", "ɛ", "a"],
    phonemes: [
      {
        id: "it-fresca-e",
        label: "fresca",
        ipa: "e",
        kind: "vowel",
        start: 0.34,
        end: 0.5,
        target: { f1: 430, f2: 2100, tolerance: 360 },
        cue: "Keep /e/ closed and bright, with little diphthong movement.",
      },
      {
        id: "it-etta-epsilon",
        label: "è",
        ipa: "ɛ",
        kind: "vowel",
        start: 0.58,
        end: 0.72,
        target: { f1: 610, f2: 1900, tolerance: 390 },
        cue: "Lower the jaw for open /ɛ/ while keeping the tongue forward.",
      },
    ],
  },
];

export const defaultSentence = practiceSentences[0];
